import React from 'react';
import { RequiredDocument } from '../../../pages/debtor/DocumentValidation';

interface DocumentChecklistProps {
  requiredDocuments: RequiredDocument[];
}

export default function DocumentChecklist({ requiredDocuments }: DocumentChecklistProps) {
  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-4 border-b">
        <h3 className="text-lg font-semibold">Checklist Dokumen Wajib</h3>
      </div>
      <div className="p-4">
        <div className="grid md:grid-cols-5 gap-4">
          {requiredDocuments.map((doc, index) => (
            <div key={doc.type} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <div className="w-8 h-8 rounded-full bg-amber-100 flex items-center justify-center text-sm font-semibold text-amber-700">
                {index + 1}
              </div>
              <span className="text-sm font-medium">{doc.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
